import React from 'react';
import { GlowingButton } from '../ui/GlowingButton';
import { motion } from 'framer-motion';
import { CheckCircle2, Timer, ShieldCheck, CreditCard } from 'lucide-react';
export function FinalCtaSection() {
  return <section className="py-32 relative overflow-hidden bg-black" data-id="element-13">
      {/* Background Effects (Grid & Glow) */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#4f4f4f2e_1px,transparent_1px),linear-gradient(to_bottom,#4f4f4f2e_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] z-0" data-id="element-14" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[400px] bg-cyan-500/20 blur-[120px] rounded-full pointer-events-none z-0" data-id="element-15" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-16">
        <div className="max-w-4xl mx-auto text-center" data-id="element-17">
          
          {/* 1. URGENCY TIMER BADGE */}
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-6 py-2 rounded-full bg-red-500/10 border border-red-500/30 text-red-400 font-bold tracking-widest mb-8 animate-pulse" data-id="element-18">
            <Timer className="w-5 h-5" data-id="element-19" />
            OFERTA EXPIRA PRONTO
          </motion.div>

          {/* 2. HEADLINE */}
          <h2 className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight" data-id="element-20">
            NO DEJES PASAR ESTA <br data-id="element-21" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-600" data-id="element-22">
              OPORTUNIDAD ÚNICA
            </span>
          </h2>

          <p className="text-xl text-gray-400 mb-12 max-w-2xl mx-auto" data-id="element-23">
            El precio subirá a <span className="text-red-400 line-through decoration-2" data-id="element-24">$97</span> en cuanto termine el lanzamiento. Asegura tu acceso de por vida hoy.
          </p>

          {/* 3. RECAP BOX (Lo que te llevas) */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 max-w-2xl mx-auto mb-12 text-left shadow-2xl backdrop-blur-sm" data-id="element-25">
            <h3 className="text-gray-400 text-sm font-bold uppercase tracking-wider mb-4 border-b border-white/10 pb-2" data-id="element-26">
              RESUMEN DE TU PEDIDO:
            </h3>
            <ul className="space-y-3" data-id="element-27">
              <li className="flex items-center justify-between group" data-id="element-28">
                <span className="flex items-center gap-3 text-white text-lg" data-id="element-29"><CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-30" /> Masterkit IA Completo</span>
                <span className="text-gray-500 line-through text-sm group-hover:text-white transition-colors" data-id="element-31">$47</span>
              </li>
              <li className="flex items-center justify-between group" data-id="element-32">
                <span className="flex items-center gap-3 text-white text-lg" data-id="element-33"><CheckCircle2 className="w-5 h-5 text-cyan-400" data-id="element-34" /> Bono: Biblia de Prompts</span>
                <span className="text-gray-500 line-through text-sm group-hover:text-white transition-colors" data-id="element-35">$27</span>
              </li>
              <li className="flex items-center justify-between group" data-id="element-36">
                <span className="flex items-center gap-3 text-white text-lg" data-id="element-37"><CheckCircle2 className="w-5 h-5 text-cyan-400" data-id="element-38" /> Bono: Toolbox Secreta</span>
                <span className="text-gray-500 line-through text-sm group-hover:text-white transition-colors" data-id="element-39">$19</span>
              </li>
              <li className="flex items-center justify-between group" data-id="element-40">
                <span className="flex items-center gap-3 text-white text-lg" data-id="element-41"><CheckCircle2 className="w-5 h-5 text-cyan-400" data-id="element-42" /> Bono: Checklist Diaria</span>
                <span className="text-gray-500 line-through text-sm group-hover:text-white transition-colors" data-id="element-43">$9</span>
              </li>
            </ul>
            <div className="mt-6 pt-4 border-t border-white/10 flex items-center justify-between" data-id="element-44">
              <span className="text-xl text-gray-300 font-medium" data-id="element-45">Total a pagar hoy:</span>
              <div className="text-right" data-id="element-46">
                <span className="block text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-cyan-400" data-id="element-47">
                  $19.99
                </span>
              </div>
            </div>
          </div>

          {/* 4. FINAL CTA BUTTON */}
          <div className="flex flex-col items-center gap-6" data-id="element-48">
            <GlowingButton variant="green" size="xl" className="w-full md:w-auto min-w-[320px] text-xl shadow-[0_0_60px_rgba(34,197,94,0.3)] hover:shadow-[0_0_80px_rgba(34,197,94,0.5)] transition-all transform hover:scale-105" data-id="element-49">
              DESCARGAR PACK AHORA
            </GlowingButton>

            {/* Trust Elements */}
            <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-500 opacity-80" data-id="element-50">
              <span className="flex items-center gap-2" data-id="element-51">
                <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-52" /> Garantía 7 días
              </span>
              <span className="flex items-center gap-2" data-id="element-53">
                <CreditCard className="w-4 h-4 text-blue-500" data-id="element-54" /> Pago 100% Seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-55">
                <CheckCircle2 className="w-4 h-4 text-purple-500" data-id="element-56" /> Entrega Inmediata
              </span>
            </div>
          </div>

        </div>
      </div>
    </section>;
}